import { TOKENS as T } from "../styles/styles";

// Shared sheet shell used by EntryDetailSheet and EntryFormSheet, so the sheet
// chrome exists exactly once in the codebase.
export default function BottomSheet({ onClose, children }) {
  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={sheetStyle} onClick={(event) => event.stopPropagation()}>
        <div style={handleWrapStyle}>
          <div style={handleStyle} />
        </div>

        <div style={scrollStyle} className="scrollbar-hide">
          {children}
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  zIndex: 50,
};

const sheetStyle = {
  position: "relative",
  background: T.card,
  borderTopLeftRadius: 32,
  borderTopRightRadius: 32,
  maxHeight: "88%",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 -20px 40px rgba(0,0,0,0.16)",
};

const handleWrapStyle = {
  display: "flex",
  justifyContent: "center",
  padding: "14px 0 4px",
  flexShrink: 0,
};

const handleStyle = {
  width: 40,
  height: 4,
  borderRadius: 999,
  background: "rgba(136,136,153,0.25)",
};

const scrollStyle = {
  overflowY: "auto",
  padding: "0 20px 32px",
};
